import ReactGA from 'react-ga';

export const initAnalytics = (trackingId = '', options = {}) => {
    ReactGA.initialize(
        trackingId,
        { ...options }
    );
};

export const setAnalytics = ({ fields = {}, trackerNames = [] }) => {
    ReactGA.set(
        { ...fields },
        [...trackerNames]
    );
};

export const setPageViewAnalytics = ({ pageUrl = '', trackerNames = [], title = '' }) => {
    ReactGA.pageview(
        pageUrl,
        [...trackerNames],
        title
    );
};

export const setModalViewAnalytics = ({ modalName = '' }) => {
    ReactGA.modalview(modalName)
};

export const setEvent = ({ args = {} }) => {
    ReactGA.event({
        ...args
    });
};

export const setAnalyticsTiming = ({ args = {} }) => {
    ReactGA.timing({
        ...args
    });
};

export const accessGA = (args = []) => {
    if (args.length) {
        ReactGA.ga(...args)
    }
    else {
        return ReactGA.ga();
    }
};

export const setAnalyticsOutboundLink = ({
    args = {},
    trackerNames = [],
    hitCallback = () => { },
}) => {
    ReactGA.outboundLink(
        { ...args },
        hitCallback,
        [...trackerNames]
    );
};

export const handleAnalyticsException = ({ args = { description: '', fatal: false } }) => {
    ReactGA.exception({ ...args })
};

export const requireAnalyticsPlugin = ({ name, options = {} }) => {
    ReactGA.plugin.require(
        name,
        { ...options }
    );
};

export const executePluginAction = ({
    pluginName = '',
    action = '',
    actionType = [],
    payload = {}
}) => {
    ReactGA.plugin.execute(
        pluginName,
        action,
        [...actionType],
        { ...payload }
    );
};

export const setAnalyticsProcess = ({
    title = '',
    pageUrl = '',
    trackingId = '',
    fields = {},
    options = {},
    eventArgs = {},
    trackerNames = [],
}) => {
    trackingId && initAnalytics(trackingId, options);
    setAnalytics(fields, trackerNames);
    setPageViewAnalytics(pageUrl, trackerNames, title);
    setEvent(eventArgs);
}